import React from 'react';
import HeroSection from "../general/HeroSection";


import { Link } from "react-router-dom";

export default function ImgGizmo() {
  return (
    <>
      <section className='px-3'>
      <HeroSection title="Image Gizmo" subtitle="Every tool you could want to edit your text.  Your online text editor is here and forever free!"/>
<div className="container d-desktop">
          
      {/* <div className="text-center mb-4">
          <div className="section-title text-gradient">
            Text Gizmo
          </div>
          <div className="section-subTitle">
            Every tool you could want to edit your text. Your online text editor is here and forever free!
          </div>
          </div> */}
        
          <div className="row py-5" >
            <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              <Link to="/text-gizmo/convert-case" >
              <div className="gizmo-card ">
                <div className="gizmo-img">
                  <img src="" alt="" className="img-fluid" />
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                    PNG to WEBP
                  </div>
                  <div className="gizmo-desc">
                  Easily transform your text with Text Convert, your go-to tool for quick and efficient text format changes.
                  </div>
                  <Link to="/code-gizmo" className="gizmo-card-link">
                  Transform Your Text!
                      </Link>
                </div>
              </div>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              <Link to="/text-gizmo/convert-case" >
              <div className="gizmo-card ">
                <div className="gizmo-img">
                  <img src="" alt="" className="img-fluid" />
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                     JPG to WEBP
                  </div>
                  <div className="gizmo-desc">
                  Easily transform your text with Text Convert, your go-to tool for quick and efficient text format changes.
                  </div>
                  <Link to="/code-gizmo" className="gizmo-card-link">
                  Transform Your Text!
                      </Link>
                </div>
              </div>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              <Link to="/text-gizmo/replace-text" >
              <div className="gizmo-card ">
                <div className="gizmo-img">
                  <img src="" alt="" className="img-fluid" />
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                   PNG to PDF 
                  </div>
                  <div className="gizmo-desc">
                  Easily search for specific words or phrases and replace them in seconds with the Find and Replace Text tool.                  </div>
                  <Link to="/code-gizmo" className="gizmo-card-link">
                  Simplify Your Text Editing!
                      </Link>
                </div>
              </div>
              </Link>
            </div>
          </div>
        
      
          </div>
      </section>
    </>
  )
}
